import { USER_UPDATE, ADD_CONVERSATION } from '../../types/conversations'

export default function user(state = {}, action) {
  // If we don't have any user, return
  if (!action.user) return state

  switch (action.type) {
    case ADD_CONVERSATION: {
      return action.user
    }
    case USER_UPDATE: {
      return action.user
    }
    default: {
      return state
    }
  }
}
